import { render, staticRenderFns } from "./TopicTurntableWeapon.vue?vue&type=template&id=d268a9a8&scoped=true"
import script from "./TopicTurntableWeapon.vue?vue&type=script&lang=js"
export * from "./TopicTurntableWeapon.vue?vue&type=script&lang=js"
import style0 from "./TopicTurntableWeapon.vue?vue&type=style&index=0&id=d268a9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d268a9a8",
  null
  
)

export default component.exports